var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-navigation'),(!_vm.isAuthenticated && _vm.$vuetify.breakpoint.mdAndUp)?_c('side-navigation'):_vm._e(),_c('v-content',{attrs:{"transition":"slide-x-transition"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }